import { registerApi as api } from '../../api';
export const fetchReturnsForms = async (unit_id) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.get('/get_returns_forms', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: { unit_id },
    });
    return response.data;
  } catch (error) {
    const body = error.response?.data;
    const msg =
      (typeof body?.message === 'string' && body.message) ||
      (typeof body?.error === 'string' && body.error) ||
      body?.error?.message ||
      error.message;
    throw msg || 'Failed to load returns';
  }
};
const pickRegisterError = (error) => {
  const d = error.response?.data;
  if (typeof d?.message === 'string') return d.message;
  if (typeof d?.error === 'string') return d.error;
  return error.response?.data?.error?.message || error.message;
};

export const fetchReturnsFormsnew = async (unit_id) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.get('/get_returns_forms', {
      headers: { Authorization: `Bearer ${token}` },
      params: { unit_id },
    });
    return response.data;
  } catch (error) {
    throw pickRegisterError(error);
  }
};

export const fetchReturnFormById = async (id) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.get(`/get_return_form/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    throw pickRegisterError(error);
  }
};

export const createReturnsFormApi = async (payload) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.post('/create_returns_form', payload, {
      headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    });
    return response.data;
  } catch (error) {
    throw pickRegisterError(error);
  }
};

export const updateReturnsFormApi = async (id, payload) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.put(`/update_returns_form/${id}`, payload, {
      headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    });
    return response.data;
  } catch (error) {
    throw pickRegisterError(error);
  }
};

export const deleteReturnsFormApi = async (id) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.delete(`/delete_returns_form/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    throw pickRegisterError(error);
  }
};




// export const CreateGenerateReturnForm = async (formInput, options = {}) => {
//   try {
//     const token = sessionStorage.getItem('token');
//     const { autoDownload = true } = options;
//     const nForms = Array.isArray(formInput.form_types) ? formInput.form_types.length : 1;
//     // #region agent log
//     fetch('http://127.0.0.1:7243/ingest/e43dfde6-fd99-48e1-94e8-f943bd034c5a', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json', 'X-Debug-Session-Id': '01c993' },
//       body: JSON.stringify({
//         sessionId: '01c993',
//         hypothesisId: 'H3',
//         location: 'generateForm.api.jsx:CreateGenerateForm:before_post',
//         message: 'selected_retuns_form_generation request',
//         data: { nForms, format: formInput.format },
//         timestamp: Date.now(),
//       }),
//     }).catch(() => {});
//     // #endregion

//     const response = await api.post('/selected_retuns_form_generation', formInput, {
//       responseType: 'blob',
//       timeout: 30 * 60 * 1000,
//       headers: {
//         'Authorization': `Bearer ${token}`
//       }
//     });

//     // ✅ Determine extension based on requested format
//     const format = formInput.format || 'excel';
//     const extMap = {
//       excel : { ext: 'xlsx', mime: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' },
//       pdf   : { ext: 'pdf',  mime: 'application/pdf' },
//       both  : { ext: 'zip',  mime: 'application/zip' },
//     };
//     const { ext } = extMap[format] || extMap['excel'];

//     // ✅ Build filename dynamically (prefer backend filename when provided)
//     const disposition = response.headers?.['content-disposition'];
//     let headerFilename = null;
//     if (disposition && disposition.includes('filename=')) {
//       headerFilename = disposition.split('filename=')[1].replace(/['"]/g, '').trim();
//     }
//     const fallbackName = `${formInput.client_name}_${formInput.unit_id}_${formInput.form_type || 'forms'}_${formInput.date}.${ext}`;
//     const fileName = headerFilename || fallbackName;

//     if (autoDownload) {
//       // ✅ Trigger download
//       const url = window.URL.createObjectURL(new Blob([response.data]));
//       const link = document.createElement('a');
//       link.href = url;
//       link.setAttribute('download', fileName);
//       document.body.appendChild(link);
//       link.click();
//       link.parentNode.removeChild(link);
//       window.URL.revokeObjectURL(url);
//     }

//     return {
//       data: response.data,
//       status: response.status,
//       fileName,
//       failuresSummary: response.headers?.['x-form-generation-failures'] || null,
//     };

//   } catch (error) {
//     if (error.response && error.response.data) {
//       // Blob error response — parse JSON error message from blob
//       return new Promise((resolve) => {
//         const reader = new FileReader();
//         reader.onload = function () {
//           try {
//             const payload = JSON.parse(reader.result);
//             const errorMsg = payload?.error || 'Something went wrong';
//             resolve({ data: null, error: errorMsg, errorPayload: payload });
//           } catch (e) {
//             resolve({ data: null, error: 'Something went wrong' });
//           }
//         };
//         reader.readAsText(error.response.data);
//       });
//     } else {
//       // #region agent log
//       fetch('http://127.0.0.1:7243/ingest/e43dfde6-fd99-48e1-94e8-f943bd034c5a', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json', 'X-Debug-Session-Id': '01c993' },
//         body: JSON.stringify({
//           sessionId: '01c993',
//           hypothesisId: 'H3',
//           location: 'generateForm.api.jsx:CreateGenerateForm:catch_no_response',
//           message: error?.message || 'request failed',
//           data: {
//             code: error?.code,
//             status: error?.response?.status,
//             nForms: Array.isArray(formInput.form_types) ? formInput.form_types.length : 1,
//           },
//           timestamp: Date.now(),
//         }),
//       }).catch(() => {});
//       // #endregion
//       return { data: null, error: error.message };
//     }
//   }
// };

// get_return_selected_year


export const CreateGenerateReturnForm = async (formInput, options = {}) => {
  try {
    const token = sessionStorage.getItem('token');
    const { autoDownload = true } = options;
    const nForms = Array.isArray(formInput.form_types) ? formInput.form_types.length : 1;

    // #region agent log
    fetch('http://127.0.0.1:7243/ingest/e43dfde6-fd99-48e1-94e8-f943bd034c5a', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Debug-Session-Id': '01c993' },
      body: JSON.stringify({
        sessionId: '01c993',
        hypothesisId: 'H3',
        location: 'generateForm.api.jsx:CreateGenerateForm:before_post',
        message: 'selected_retuns_form_generation request',
        data: { nForms, format: formInput.format },
        timestamp: Date.now(),
      }),
    }).catch(() => {});
    // #endregion

    const response = await api.post('/selected_retuns_form_generation', formInput, {
      responseType: 'blob',
      timeout: 30 * 60 * 1000,
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    // ── Extension / MIME map for every supported format ───────────────────────
    // Matches the backend's accepted `format` values exactly.
    const format = (formInput.format || 'excel').toLowerCase();
    const extMap = {
      excel : { ext: 'xlsx', mime: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' },
      pdf   : { ext: 'pdf',  mime: 'application/pdf' },
      word  : { ext: 'docx', mime: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' },
      docx  : { ext: 'docx', mime: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' },
      doc   : { ext: 'doc',  mime: 'application/msword' },
      both  : { ext: 'zip',  mime: 'application/zip' },
      all   : { ext: 'zip',  mime: 'application/zip' },
    };

    // Fall back to excel if an unrecognised format string arrives
    const { ext, mime } = extMap[format] ?? extMap['excel'];

    // ── Prefer filename from Content-Disposition header ───────────────────────
    const disposition = response.headers?.['content-disposition'];
    let headerFilename = null;
    if (disposition && disposition.includes('filename=')) {
      headerFilename = disposition.split('filename=')[1].replace(/['"]/g, '').trim();
    }
    const fallbackName = `${formInput.client_name}_${formInput.unit_id}_${formInput.form_type || 'forms'}_${formInput.date}.${ext}`;
    const fileName = headerFilename || fallbackName;

    if (autoDownload) {
      // Use the correct MIME type so the browser sets the right file association
      const url = window.URL.createObjectURL(new Blob([response.data], { type: mime }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
    }

    return {
      data: response.data,
      status: response.status,
      fileName,
      failuresSummary: response.headers?.['x-form-generation-failures'] || null,
      generatedFormId: response.headers?.['x-generated-form-id'] || null,
    };

  } catch (error) {
    if (error.response && error.response.data) {
      // Blob error response — parse JSON error message from blob
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = function () {
          try {
            const payload = JSON.parse(reader.result);
            const errorMsg = payload?.error || 'Something went wrong';
            resolve({ data: null, error: errorMsg, errorPayload: payload });
          } catch (e) {
            resolve({ data: null, error: 'Something went wrong' });
          }
        };
        reader.readAsText(error.response.data);
      });
    } else {
      // #region agent log
      fetch('http://127.0.0.1:7243/ingest/e43dfde6-fd99-48e1-94e8-f943bd034c5a', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Debug-Session-Id': '01c993' },
        body: JSON.stringify({
          sessionId: '01c993',
          hypothesisId: 'H3',
          location: 'generateForm.api.jsx:CreateGenerateForm:catch_no_response',
          message: error?.message || 'request failed',
          data: {
            code: error?.code,
            status: error?.response?.status,
            nForms: Array.isArray(formInput.form_types) ? formInput.form_types.length : 1,
          },
          timestamp: Date.now(),
        }),
      }).catch(() => {});
      // #endregion
      return { data: null, error: error.message };
    }
  }
};



export const uploadReturnGeneratedFile = async ({
  file,
  client_id,
  unit_id,
  date,
  form_type,
  mode,
  company_code,
}) => {
  try {
    const token = sessionStorage.getItem('token');
    const formData = new FormData();
    formData.append('file', file);
    formData.append('client_id', client_id);
    formData.append('unit_id', unit_id);
    formData.append('date', date);
    formData.append('form_type', form_type);
    formData.append('mode', mode);
    if (company_code) {
      formData.append('company_code', company_code);
    }
    const response = await api.post('/create_generated_form', formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    const body = error.response?.data;
    const msg =
      (typeof body?.message === 'object' && body?.message?.error) ||
      (typeof body?.message === 'string' && body.message) ||
      (typeof body?.error === 'string' && body.error) ||
      error.message;
    throw msg || 'Upload failed';
  }
};

export const fetchReturnsFormsYear = async (client_id,unit_id,form_name) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.get('/get_return_selected_year', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: { client_id:client_id, unit_id:unit_id, form_name:form_name },
    });
    return response.data;
  } catch (error) {
    const body = error.response?.data;
    const msg =
      (typeof body?.message === 'string' && body.message) ||
      (typeof body?.error === 'string' && body.error) ||
      body?.error?.message ||
      error.message;
    throw msg || 'Failed to load returns';
  }
};


// export const fetchReturnSelectedYear = async (client_id, unit_id, form_name) => {
//   try {
//     const token = sessionStorage.getItem('token');
//     const response = await api.get('/get_return_selected_year', {
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//       params: {
//         client_id,
//         unit_id,
//         form_name,
//       },
//     });
//     return response.data;
//   } catch (error) {
//     const d = error.response?.data;
//     const msg =
//       (typeof d?.message === 'string' && d.message) ||
//       (typeof d?.error === 'string' && d.error) ||
//       error.message ||
//       'Failed to load return year context';
//     throw msg;
//   }
// };






